/**
 * Barre d'annonce — un message plus large que la place disponible GLISSE
 * pendant sa fenêtre d'affichage au lieu d'être tronqué ; l'alternance des
 * deux messages ne change pas (demande mhkdesign 2026-09-13).
 *
 * On ne fait ici que mesurer : le débordement devient `--dx` (négatif) et
 * la classe `anno-msg--defile`, l'animation vit en CSS. Sous 760px la barre
 * défile en continu (defile.js) et cette mesure ne s'applique pas.
 */
const MOBILE = window.matchMedia('(max-width: 760px)');

function poser(piste) {
  const groupe = piste.querySelector('[data-defile-groupe]') ?? piste;
  for (const msg of groupe.querySelectorAll('.anno-msg')) {
    const dx = MOBILE.matches ? 0 : Math.min(0, piste.clientWidth - msg.scrollWidth);
    msg.classList.toggle('anno-msg--defile', dx < 0);
    msg.style.setProperty('--dx', `${dx}px`);
  }
}

function tout() {
  document.querySelectorAll('.anno-l').forEach(poser);
}

tout();
document.fonts?.ready.then(tout);

const observateur = new ResizeObserver(tout);
document.querySelectorAll('.anno-l').forEach((piste) => observateur.observe(piste));

// L'éditeur de thème remplace le HTML de la section à chaque réglage.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.anno-l').forEach((piste) => {
    observateur.observe(piste);
    poser(piste);
  });
});
